import { LocalizationProvider } from "@mui/x-date-pickers";
import {
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  StyledDateContainer,
} from "../StyledComponents/StyledFields";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Typography } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

interface BasicDatePickerIProps {
  isDatePickerOpen?: boolean;
  setDatePickerOpen?: React.Dispatch<React.SetStateAction<any>>;
  date: string;
  handleDateChange: (field: string, value: any) => void;
  errorMessage: string | undefined;
  id?: string;
  readOnly?: boolean;
  name?: string;
}

const styles = {
  textField: {
    border: "1px solid rgba(136, 46, 20, 0.4)",
    backgroundColor: "#FFF9E4",
    borderRadius: "8px",
  },
  errorTextField: {
    border: "1px solid #f05802",
    borderRadius: "8px",
    width: "100%",
    backgroundColor: "#FFF9E4",
  },
};

const CustomDatePickerField = (
  props: BasicDatePickerIProps
): React.ReactElement => {
  const {
    date,
    handleDateChange,
    errorMessage,
    id,
    readOnly,
    name,
  } = props;

  const [isDatePickerOpen, setDatePickerOpen] = useState(false)

  const onClickContainer = () => {
    if (!readOnly) {
      setDatePickerOpen(true);
    }
  };

  const handleDateChangeInternal = (value: any) => {
    if (!readOnly) {
      handleDateChange(name ? name : "date", value);
    }
  };

  useEffect(() => {
    setDatePickerOpen(false);
  }, [date])

  return (
    <div style={{ minWidth: "100%", borderRadius: "8px" }}>
      <StyledDateContainer
        id={id}
        sx={{
          backgroundColor: "#FFF9E4",
          borderRadius: "8px",
          height: "48px",
        }}
        onClick={onClickContainer}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DateTimePicker"]}>
            <CustomDatePicker
              // open={isDatePickerOpen && !readOnly}
              // onClose={() => setDatePickerOpen(false)}
              slots={{
                openPickerIcon: CustomCalendarTodayOutlinedIcon,
              }}
              slotProps={{
                inputAdornment: {
                  position: "end",
                },
              }}
              format="MM-DD-YYYY"
              value={date ? dayjs(date, "MM-DD-YYYY") : ""}
              onChange={(value) => handleDateChangeInternal(value)}
              sx={errorMessage ? styles?.errorTextField : styles?.textField}
              readOnly={readOnly}
              disabled={readOnly} // Also set disabled on the TextField to prevent input
            />
          </DemoContainer>
        </LocalizationProvider>
        {errorMessage ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage}
          </Typography>
        ) : (
          ""
        )}
      </StyledDateContainer>
    </div>
  );
};

export default CustomDatePickerField;
